import React from "react";
import styled from "styled-components";
import NavBar from "./NavBar";
import Description from "header/Description";
import TopDummy from "header/TopDummy";

const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-sizing: border-box;
`;

export const Header = () => {
  const navBarHeights = [40, 40, 50];
  const desciptionHeights = [30, 0, 0];
  const dummyHeights = navBarHeights.map((value, index) => value + desciptionHeights[index]);

  return (
    <div className="Header">
      <StyledHeader>
        <NavBar heights={navBarHeights} />
        <Description heights={desciptionHeights} />
      </StyledHeader>
      <TopDummy heights={dummyHeights} />
    </div>
  );
};